var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('CForm',{on:{"submitFields":_vm.updateCode}}),_c('CPreview',{attrs:{"arr":_vm.formFields}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }